"use strict";
var forms_1 = require("@angular/forms");
var view_models_1 = require("./../view-models");
// Validates that either a valid flight or postponed selection are present on the form
function conditionalFlightsValidator() {
    return function (control) {
        if (control instanceof forms_1.FormGroup) {
            var postponedControl = control.get('postponedFlights');
            var flightsControl = control.get('flights');
            if (!postponedControl || !flightsControl) {
                console.warn('Controls required for performing validation are not present');
            }
            if (postponedControl instanceof forms_1.FormControl && flightsControl instanceof forms_1.FormArray) {
                var flights = flightsControl.value;
                var flightsAreEmpty = !(flights.length > 0) || Boolean(flights.find(function (flight) {
                    return view_models_1.FlightViewModel.isEmpty(flight);
                }));
                var postponed = postponedControl.value;
                if (flightsAreEmpty && !postponed.noFlights) {
                    return { 'flightOrPostponeRequired': true };
                }
            }
            else {
                console.warn('Controls required for performing validation are not the correct type');
            }
        }
        else {
            console.error('This validator must only be used on a FormGroup');
        }
        return null;
    };
}
exports.conditionalFlightsValidator = conditionalFlightsValidator;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/validators/conditional-flights.validator.js